import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Draggable } from 'react-beautiful-dnd';

import Actions from './Actions';

export default function Item({ item, index, setTypeView }) {
  const getItemStyle = (isDragging, draggableStyle) => ({
    userSelect: 'none',
    opacity: isDragging ? 0.5 : 1,
    ...draggableStyle,
  });

  return (
    <Draggable draggableId={item.id} index={index}>
      {(provided, snapshot) => (
        <li
          className="list-group-item"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={getItemStyle(
            snapshot.isDragging,
            provided.draggableProps.style,
          )}
        >
          <Row>
            <Col md={10}>
              <i className="fa fa-bars mr10" />
              {item.attributes.name}
              {item.attributes.category_default && <strong className="ml5">(Default)</strong>}
            </Col>
            <Col md={2} className="text-right">

              <Actions row={item} setTypeView={setTypeView} />
            </Col>
          </Row>
        </li>
      )}
    </Draggable>
  );
}
